import { gql } from '@apollo/client'

export default gql(`
    mutation deleteBucketDisplayType($id: ID! $project: String) {
        deleteDisplayType(
            input: {
                id: $id
            }
            project: $project
        ) {
            id
            key
            name
        }
    }`
)
